// extracted by mini-css-extract-plugin
export default {"inputPhone":"f3mJqaHNjqas_hevtMCE"};